import { render, staticRenderFns } from "./Upgrade.vue?vue&type=template&id=dd6b3406&scoped=true"
import script from "./Upgrade.vue?vue&type=script&lang=js"
export * from "./Upgrade.vue?vue&type=script&lang=js"
import style0 from "~/sass/pages/landing/summit.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Upgrade.vue?vue&type=style&index=1&id=dd6b3406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6b3406",
  null
  
)

export default component.exports